import React from 'react';
import { Box, Skeleton } from '@mui/material';
import * as cardStyles from '../publisherCard/styles';
import * as styles from './styles';

// Mirrors publisherCard's DOM shape 1:1 (same card/header/pills tokens) so
// the grid holds its layout with zero shift once real cards swap in.
function PublisherCardSkeleton() {
    return (
        <Box sx={cardStyles.card}>
            <Box sx={cardStyles.header}>
                <Skeleton variant="rounded" animation="pulse" sx={{ ...cardStyles.logo, ...styles.tile }} />
                <Box sx={cardStyles.publisherInfo}>
                    <Skeleton variant="text" animation="pulse" width="60%" height={20} sx={styles.tile} />
                    <Box sx={{ ...cardStyles.categories, mt: 0.75 }}>
                        <Skeleton variant="rounded" animation="pulse" width={48} height={14} sx={styles.chip} />
                        <Skeleton variant="rounded" animation="pulse" width={48} height={14} sx={styles.chip} />
                    </Box>
                </Box>
                <Skeleton variant="rounded" animation="pulse" sx={{ ...cardStyles.shareButton, width: 28, height: 28 }} />
            </Box>
            <Box sx={cardStyles.pills}>
                <Skeleton variant="rounded" animation="pulse" width={60} sx={styles.pill} />
                <Skeleton variant="rounded" animation="pulse" width={80} sx={styles.pill} />
            </Box>
            <Box sx={cardStyles.nextEvent} />
            <Skeleton variant="rounded" animation="pulse" sx={styles.button} />
        </Box>
    );
}

export default PublisherCardSkeleton;
